import CrudActionSetBase from './CrudActionSetBase'

export class VerificationMethodActionSet extends CrudActionSetBase('verificationMethod'){}
export default new VerificationMethodActionSet()